export default __webpack_public_path__ + "static/media/identity-fraud@3x.3701c9ba.jpg";